import LeftArrowIcon from './LeftArrowIcon'

export default LeftArrowIcon
